/* import __COLOCATED_TEMPLATE__ from './trigger-examples-modal.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import {
  SHOULD_TRIGGER_EXAMPLES,
  type TriggerExampleType,
} from 'embercom/lib/operator/custom-bots/constants';

interface Args {
  onClose: () => void;
  customBot: $TSFixMe;
  exampleType: TriggerExampleType;
}

export default class TriggerExamplesModal extends Component<Args> {
  @service declare intl: IntlService;

  get modalTitle(): string {
    return this.args.exampleType === SHOULD_TRIGGER_EXAMPLES
      ? this.intl.t(
          'operator.workflows.visual-builder.workflow-trigger-node.fin-task.should-trigger-examples-title',
        )
      : this.intl.t(
          'operator.workflows.visual-builder.workflow-trigger-node.fin-task.should-not-trigger-examples-title',
        );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::TriggerExamplesModal': typeof TriggerExamplesModal;
    'workflows/graph-editor/trigger-examples-modal': typeof TriggerExamplesModal;
  }
}
